import { Component } from '@angular/core';
import { membersuiteGLAccountEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: GL Accounts') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteglaccount-form',
    templateUrl: './membersuiteglaccount.form.component.html'
})
export class membersuiteGLAccountFormComponent extends BaseFormComponent {
    public record!: membersuiteGLAccountEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

